import { z } from "zod";
import { IsoDateTime } from "@secretaa/http-contract";
import { Digest,Ref,Version } from "../work-os/primitives.ts";
import { SurfaceType } from "./spec.ts";
import { SurfaceMetadataSnapshot } from "./snapshot.ts";
import { SurfaceDependency } from "./lifecycle.ts";
/** Canonical-owner packet. Public draft/preview bodies never accept this evidence. */
export const SurfaceCompilationEvidence=z.object({metadata:SurfaceMetadataSnapshot,
 dependencies:z.array(SurfaceDependency).max(127),
 rendererRelease:z.object({ref:Ref,digest:Digest,contractRef:Ref,type:SurfaceType,contractVersion:Version,available:z.boolean(),checkedAt:IsoDateTime,expiresAt:IsoDateTime}).strict(),
}).strict();
export type SurfaceCompilationEvidence=z.infer<typeof SurfaceCompilationEvidence>;

/** Trusted release/policy owner response. It is never accepted in public surface commands. */
export const SurfaceReleaseAuthorityEvidence=z.object({
 scope:SurfaceMetadataSnapshot.shape.scope,
 policy:z.object({ref:Ref,digest:Digest,available:z.boolean()}).strict(),
 rendererRelease:SurfaceCompilationEvidence.shape.rendererRelease,
 checkedAt:IsoDateTime,expiresAt:IsoDateTime,
}).strict();
export type SurfaceReleaseAuthorityEvidence=z.infer<typeof SurfaceReleaseAuthorityEvidence>;
